/* Church Sign Shop — Collection page (Greeting Signs).
   Cards are built from the shared design registry (snippets/design-registry
   .liquid → <script data-design-registry>) and drawn with the configurator's
   canvas renderer (sign-templates.js), so every thumbnail matches the editor
   preview and the print file. Each card deep-links into the configurator
   with that design preselected (?design=<handle>).
   Client-side shape switch + sort (Most Popular | Newest | A → Z). On a
   design_category page the root carries data-category, which pins the grid
   to that category's designs.                                    */
(function () {
  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var grid     = root.querySelector('[data-grid]');
  var chips    = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
  var sortSel  = root.querySelector('[data-sort]');
  var empty    = root.querySelector('[data-empty]');
  var countEl  = root.querySelector('[data-count]');
  var seeAll   = root.querySelector('[data-see-all]');

  /* ── data ─────────────────────────────────────────────────────────── */
  var designs = [], cfg = { productUrl: '/products/custom-church-welcome-sign', fromPrice: '', print: {} };
  try {
    var regEl = document.querySelector('[data-design-registry]');
    if (regEl) designs = JSON.parse(regEl.textContent || '[]') || [];
  } catch (e) { designs = []; }
  try {
    var cfgEl = document.querySelector('[data-collection-config]');
    if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent || '{}'));
  } catch (e) { /* defaults */ }
  var bleedIn = parseFloat(cfg.print && cfg.print.bleedIn) || 1;
  var radiusIn = parseFloat(cfg.print && cfg.print.cornerRadiusIn);
  if (isNaN(radiusIn)) radiusIn = 1;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── shape (square | rectangle | circle) — from ?shape=, default square ─ */
  var SHAPES = ['square', 'rectangle', 'circle'];
  var shape = 'square';
  try {
    var qs = new URLSearchParams(window.location.search || '').get('shape');
    if (qs && SHAPES.indexOf(qs.toLowerCase()) >= 0) shape = qs.toLowerCase();
  } catch (e) { /* default */ }
  var shapeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-shape]'));
  var shapeLabel = { square: '22" Square', rectangle: '18" × 24" Rectangle', circle: '22" Circle' };

  function cardHref(d) {
    return cfg.productUrl + '?design=' + encodeURIComponent(d.handle || d.id) + '&shape=' + shape;
  }

  /* ── build cards ──────────────────────────────────────────────────── */
  var cards = [];
  if (grid) {
    grid.innerHTML = '';
    designs.forEach(function (d) {
      var a = document.createElement('div');
      a.className = 'coll-card';
      a.setAttribute('data-card', '');
      a.setAttribute('data-tag', d.tag || '');
      a.setAttribute('data-cat', d.category || '');
      a.setAttribute('data-name', d.name || '');
      a.setAttribute('data-popular', d.popular ? '1' : '0');
      a.setAttribute('data-order', String(d.order || 0));
      a.innerHTML =
        '<a class="coll-card__media" data-card-link href="' + cardHref(d) + '" aria-label="Customize ' + esc(d.name) + '">' +
          '<canvas class="coll-card__cv" data-card-canvas width="440" height="440"></canvas>' +
          (d.popular ? '<span class="coll-card__badge">POPULAR</span>' : '') +
          '<div class="coll-card__overlay"><span class="coll-card__cta">CUSTOMIZE &#8594;</span></div>' +
        '</a>' +
        '<div class="coll-card__info">' +
          '<span class="coll-card__name">' + esc(d.name) + '</span>' +
          (cfg.pagePrefix ? '<a class="coll-card__learn" href="' + cfg.pagePrefix + encodeURIComponent(d.handle || d.id) + '" data-learn>About this design \u2192</a>' : '') +
          '<div class="coll-card__meta">' +
            '<span class="coll-card__tag" data-shape-label>22&quot; Square</span>' +
            (cfg.fromPrice ? '<span class="coll-card__price">FROM ' + esc(cfg.fromPrice) + '</span>' : '') +
          '</div>' +
        '</div>';
      a._design = d;
      grid.appendChild(a);
      cards.push(a);
    });
  }

  /* ── thumbnails (same renderer as the configurator) ───────────────── */
  var imgCache = {};
  function loadImg(url, cb) {
    var e = imgCache[url];
    if (!e) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      e = imgCache[url] = { img: im, ready: false, cbs: [] };
      im.onload = im.onerror = function () { e.ready = true; e.cbs.splice(0).forEach(function (f) { f(); }); };
      im.src = url;
    }
    if (e.ready) cb(); else e.cbs.push(cb);
  }
  function drawCard(card) {
    var ST = window.SignTemplates;
    var d = card._design;
    var cv = card.querySelector('[data-card-canvas]');
    if (!ST || !d || !cv) return;
    var media = cv.parentElement;
    var cssW = Math.max(120, Math.min(480, (media && media.clientWidth) || 300));
    var draw = function () {
      /* rectangle uses the rect export when present, else contain-fits the square art */
      var url = (shape === 'rectangle' && d.imgRect) ? (d.thumbRect || d.imgRect)
              : (shape === 'circle' && d.imgCircle) ? (d.thumbCircle || d.imgCircle) : (d.thumb || d.img);
      var sheetMatches = !(shape === 'rectangle' && !d.imgRect);
      var e2 = imgCache[url];
      ST.renderPreviewInto(cv, cssW, {
        shape: shape,
        bleedIn: bleedIn,
        cornerRadiusIn: radiusIn,
        dpr: Math.min(2, window.devicePixelRatio || 1),
        drawFull: function (ctx, ppi) {
          ST.renderOverlay({
            ctx: ctx,
            img: e2 && e2.ready ? e2.img : null,
            design: { bg: null, ink: d.ink || 'white', fields: {} },
            shape: shape, bleedIn: bleedIn, ppi: ppi,
            sheetMatches: sheetMatches,
            defaultBg: d.bg
          });
        }
      });
      cv.style.width = '100%';
      cv.style.height = 'auto';
      if (e2 && e2.ready) cv.classList.add('is-drawn');
    };
    var need = (shape === 'rectangle' && d.imgRect) ? (d.thumbRect || d.imgRect)
             : (shape === 'circle' && d.imgCircle) ? (d.thumbCircle || d.imgCircle) : (d.thumb || d.img);
    if (need) loadImg(need, draw);
    draw(); /* paint bg immediately; art fills in on load */
  }

  function setShape(next, pushUrl) {
    if (SHAPES.indexOf(next) < 0) return;
    shape = next;
    shapeBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-shape') === shape); });
    cards.forEach(function (c) {
      var link = c.querySelector('[data-card-link]');
      if (link) link.href = cardHref(c._design);
      drawCard(c);
    });
    if (pushUrl && window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      if (shape === 'square') u.searchParams.delete('shape'); else u.searchParams.set('shape', shape);
      window.history.replaceState({}, '', u.toString());
    }
    root.querySelectorAll('[data-shape-label]').forEach(function (lbl) { lbl.textContent = shapeLabel[shape]; });
  }
  shapeBtns.forEach(function (b) {
    b.addEventListener('click', function () { setShape(b.getAttribute('data-shape'), true); });
  });
  function drawAll() {
    if (!window.SignTemplates) { setTimeout(drawAll, 60); return; }
    var fonts = window.SignTemplates.loadFonts ? window.SignTemplates.loadFonts() : Promise.resolve();
    fonts.then(function () { cards.forEach(drawCard); });
  }

  /* ── filter + sort ────────────────────────────────────────────────── */
  /* Category pages pin the grid to one design_category via data-category on
     the root; the all-designs page leaves it empty and shows everything. */
  var pinnedCat = root.getAttribute('data-category') || '';
  var state = { filter: 'All', sort: 'Most Popular' };

  function apply() {
    var visible = cards.filter(function (c) {
      if (pinnedCat && c.getAttribute('data-cat') !== pinnedCat) return false;
      return state.filter === 'All' || c.getAttribute('data-tag') === state.filter;
    });
    var sorted = visible.slice();
    if (state.sort === 'Most Popular') {
      sorted.sort(function (a, b) {
        var pa = a.getAttribute('data-popular') === '1' ? 1 : 0;
        var pb = b.getAttribute('data-popular') === '1' ? 1 : 0;
        if (pb !== pa) return pb - pa;
        return parseInt(a.getAttribute('data-order'), 10) - parseInt(b.getAttribute('data-order'), 10);
      });
    } else if (state.sort === 'A → Z') {
      sorted.sort(function (a, b) {
        return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
      });
    } else if (state.sort === 'Newest') {
      sorted.sort(function (a, b) {
        return parseInt(b.getAttribute('data-order'), 10) - parseInt(a.getAttribute('data-order'), 10);
      });
    }
    cards.forEach(function (c) { c.hidden = true; });
    sorted.forEach(function (c) { c.hidden = false; grid.appendChild(c); });
    var n = sorted.length;
    if (empty) empty.hidden = n !== 0;
    if (grid) grid.style.display = n === 0 ? 'none' : '';
    if (countEl) countEl.textContent = n + ' design' + (n === 1 ? '' : 's');
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      state.filter = chip.getAttribute('data-filter');
      chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      apply();
    });
  });
  if (sortSel) {
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
  }
  if (seeAll) {
    seeAll.addEventListener('click', function (e) {
      e.preventDefault();
      state.filter = 'All';
      chips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-filter') === 'All'); });
      apply();
    });
  }

  apply();
  setShape(shape, false);
  drawAll();
  window.addEventListener('resize', function () { cards.forEach(drawCard); });
})();
